import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StayOnDeprecatedTokenService {
  stayOnDeprecatedToken: boolean;

  constructor() { }
}
